import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../utils/api";

// Import images
import recorbLogo from "../images/recorb.svg";
import downloadIcon from "../images/download.svg";

const HomePage: React.FC = () => {
  const [imagesLoaded, setImagesLoaded] = useState<{ [key: string]: boolean }>({
    recorb: false,
    download: false,
    appBg: false,
  });
  const paramsProcessed = localStorage.getItem("paramsProcessed") === "true";

  type AppItem = {
    id: number;
    name: string;
    description: string;
    appInfo?: string | null;
    logoUrl: string;
    type: string;
    latestVersion?: string | null;
  };
  const [apps, setApps] = useState<AppItem[]>([]);
  const [loadingApps, setLoadingApps] = useState(true);
  const [appsError, setAppsError] = useState<string | null>(null);

  const getDetailPath = (app: AppItem) => {
    const raw = (app.type || "").toString().trim().toLowerCase();
    const isPlugin =
      raw === "plugin" || raw === "plugins" || raw.includes("plugin");
    return isPlugin ? `/plugin/${app.id}` : `/app/${app.id}`;
  };

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await api.get("/api/app/apps");
        if (!mounted) return;
        setApps(res.data.items || []);
      } catch (e) {
        setAppsError("Failed to load apps");
      } finally {
        if (mounted) setLoadingApps(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const handleImageLoaded = (imageName: string) => {
    setImagesLoaded((prev) => ({
      ...prev,
      [imageName]: true,
    }));
  };
  if (!paramsProcessed) {
    return null;
  }

  return (
    <div className="px-6 py-8 m-auto home-page">
      {/* Row 1: Apps Panel (dynamic) */}
      <div className="grid grid-cols-4 gap-6">
        {loadingApps && (
          <div className="flex items-center p-4">
            <div className="h-[90px] w-[90px] bg-gray-200 animate-pulse rounded-md" />
            <div className="flex-1 ml-4">
              <div className="mb-2 w-40 h-6 bg-gray-200 rounded animate-pulse" />
              <div className="w-64 h-4 bg-gray-200 rounded animate-pulse" />
            </div>
          </div>
        )}
        {appsError && <div className="text-red-600">{appsError}</div>}
        {!loadingApps && !appsError && apps.length === 0 && (
          <div className="p-4 text-gray-600">No apps available.</div>
        )}
        {apps
          .filter((app) => app.latestVersion !== null)
          .map((app) => (
            <div
              key={app.id}
              className="flex items-center min-h-fit w-full h-[96px] gap-4"
            >
              <div className="flex justify-center mb-4 h-24 min-w-[90px] w-[90px] md:mb-0 md:justify-start items-center">
                {!imagesLoaded[`recorb-${app.id}`] && (
                  <div className="h-[90px] w-[90px] bg-gray-200 animate-pulse rounded-md"></div>
                )}
                <img
                  src={app.logoUrl || recorbLogo}
                  alt={`${app.name} Logo`}
                  className={`h-[90px] w-[90px] object-contain ${
                    !imagesLoaded[`recorb-${app.id}`]
                      ? "invisible absolute"
                      : ""
                  }`}
                  onLoad={() => handleImageLoaded(`recorb-${app.id}`)}
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).src = recorbLogo;
                  }}
                />
              </div>
              <div className="flex flex-col items-start h-full flex-1 max-w-full min-w-0">
                <div className="text-start mb-2 max-w-full">
                  <h2 className="text-xl font-normal mb-0 max-w-full overflow-hidden text-ellipsis whitespace-nowrap">
                    {app.name}
                  </h2>
                  <p className="text-gray-600 max-w-full overflow-hidden text-ellipsis whitespace-nowrap mb-0 leading-6">
                    {app.description}
                  </p>
                </div>
                <Link to={getDetailPath(app)} className="inline-block h-[36px]">
                  {!imagesLoaded[`download-${app.id}`] && (
                    <div className="h-[36px] w-[132px] bg-gray-200 animate-pulse rounded-md"></div>
                  )}
                  <img
                    src={downloadIcon}
                    alt={`Download ${app.name}`}
                    className={`h-[36px] w-[132px] hover:opacity-80 transition-opacity ${
                      !imagesLoaded[`download-${app.id}`]
                        ? "invisible absolute"
                        : ""
                    }`}
                    onLoad={() => handleImageLoaded(`download-${app.id}`)}
                  />
                </Link>
              </div>
            </div>
          ))}
      </div>

      {/* Row 2: All Apps Text */}
      {/* <h3 className="mb-6 text-3xl font-bold text-left">All Apps</h3> */}

      {/* Row 3: App Download Button */}
      {/* {apps.length > 0 ? (
        <Link to={`/app/${apps[0].id}`} className="block hover:opacity-90 transition-opacity min-h-[310px] max-w-[447px] ml-0">
          {!imagesLoaded.appBg && <div className="w-[447px] h-[310px] bg-gray-200 animate-pulse rounded-lg"></div>}
          <img 
            src={appBgImage} 
            alt="Download App" 
            className={`w-[447px] h-[310px] rounded-lg shadow-md ${!imagesLoaded.appBg ? 'invisible absolute' : ''}`} 
            onLoad={() => handleImageLoaded('appBg')}
          />
        </Link>
      ) : (
        <div className="block transition-opacity min-h-[310px] max-w-[447px] ml-0">
          {!imagesLoaded.appBg && <div className="w-[447px] h-[310px] bg-gray-200 animate-pulse rounded-lg"></div>}
          <img 
            src={appBgImage} 
            alt="Download App" 
            className={`w-[447px] h-[310px] rounded-lg shadow-md ${!imagesLoaded.appBg ? 'invisible absolute' : ''}`} 
            onLoad={() => handleImageLoaded('appBg')}
          />
        </div>
      )} */}
    </div>
  );
};

export default HomePage;
